<template>
  <section>
    <div class="cookies_header">
      DJULI - PROVIDED BY ZIMMER AND PEACOCK AS - Cookies Policy
    </div>
    <div class="cookies_subsection">
      Zimmer &nbsp; Peacock AS (org. no. 917 749 329) ("ZP") uses cookies and other
      information gathering methods to enhance the user experience and obtain
      information about your use of our website. Cookies are small files that are
      stored on your computer and are used to collect information while you visit
      the website.
    </div>
    <div class="cookies_subsection_header">
      This cookie policy provides information on the cookies used on ZP’s website,
      and how and why ZP uses the information collected by cookies.
    </div>
    <section>
      <div class="question">
        How and why does ZP use the information?
      </div>
      <div class="answer">
        ZP uses cookies to better understand how you use our website and collect
        statistics about your use of our website. In the long term, ZP uses this
        knowledge to improve the content and the services provided to the users
        and to optimize and further develop our website in accordance with the
        user’s needs. Cookies may also improve the website's functionality upon
        your next visit to the website. The use of cookies is based on your
        consent. You can withdraw your consent at any time, in this case, you are
        suspending the use of the service.
      </div>
      <div class="question">
        The information we collect from you by using cookies
      </div>
      <div class="answer">
        Examples of information collected through the use of cookies are browser
        information and your activities while on the website, such as IP-address,
        what third party sites that connects you to the website, the search words
        you use while at the website, the specific sites you visit at the website
        and the date and duration of the visit.
      </div>
      <div class="subanswer">
        As a visitor on our website, you will as a main rule remain anonymous.
        Note however that we collect the entire IP address. Your IP address is
        only stored for the duration of your visit at the website and will
        thereafter be either deleted or anonymized (the last digits of the number
        are removed). Your IP address is considered as personal data. More
        information about how we process personal data can be found in our
        <span> Privacy Policy</span> .
      </div>

      <div class="question">
        Purpose of cookie and data collecrted by using cookies
      </div>
      <div class="type">
        Google Analytics
      </div>
      <div class="answer">
        The purpose is web analytics service offered by Google Ireland Limited.
        (“Google”), to analyse how our website is used. This service uses cookies
        generating information on your use of our website (including your IP
        address), collected from Google in an anonymous form. Disabling these
        third-party cookies does not affect the website use. These cookies are
        used to collect information about how visitors use our website. We use the
        information to compile reports and to help us improve the website. The
        cookies collect information in an anonymous form, including the number of
        visitors to the website, where visitors have come to the website from and
        the pages they visited.
      </div>
      <div class="type">
        Login credentials
      </div>
      <div class="answer">
        The purpose is to ease the login process, by remembering the credentials
        for sign-in details.
      </div>

      <div class="question">
        How to avoid cookies
      </div>
      <div class="answer">
        In order to detect and delete cookies, you can change the settings in your
        browser. The "Help" function of your browser can help you configure your
        browser to prevent cookies or delete existing cookies. You can also learn
        how to block all new cookies on your browser and which configuration steps
        are required to receive a notification about new cookies. However, please
        note that if you choose not to accept cookies, you may not be granted
        access to all functionality on the website.
      </div>
      <div class="subanswer">
        To opt out of Google Analytics, visit
        <span @click="goToOptout">Unsubscribe</span>. You can also prevent data
        collection via Google Analytics on this website by clicking here. An
        "Opt-out Cookie" shall then be applied which shall prevent any future
        collection of the site visitor's data when visiting this website. Further
        information concerning data processing and use by Google, the settings and
        deactivation possibilities can be found in the
        <span @click="goToPolicy"> Google Privacy Policy</span> as well as in the
        <span @click="goToOptAuthenticatedUrl">Google Ads Settings</span>
      </div>

      <div class="question">
        Modification
      </div>
      <div class="answer">
        Please be advised that the above list of cookies and this policy is
        subject to change. The cookie policy will show the current policy and list
        of cookies at all times. We recommend that you check the cookie policy
        from time to time, to keep up to date with the current policy and list of
        cookies.
      </div>
      <div class="subanswer">
        Please be advised that continued use of ZP’s website following the posting
        of any changes of the policy shall constitute acceptance of such changes.
        Changes that require your consent will be disclosed through notifications
        in the website.
      </div>
      <br>
      <br>
      <br>
      <div class="lastupdated">
        Last upated : 2021.02.08
      </div>
    </section>
  </section>
</template>

<script>
export default {
  data() {
    return {
      gaoptout: 'http://tools.google.com/dlpage/gaoptout',
      authenticatedurl: 'https://adssettings.google.com/authenticated',
      policypolicies: 'https://policies.google.com/privacy',
    };
  },
  methods: {
    goToOptout() {
      window.open(this.gaoptout, '_black');
    },
    goToOptAuthenticatedUrl() {
      window.open(this.authenticatedurl, '_black');
    },
    goToPolicy() {
      window.open(this.policypolicies, '_black');
    },
  },
};
</script>

<style scoped>
span{
  color: var(--djuli-secondary-color);
  cursor: pointer;
}
.cookies_header {
  background: whitesmoke;
  padding: 1rem;
  color: var(--blue-marguerite);
  text-transform: uppercase;
}
.question {
  padding: 15px 0;
  font-weight: bold;
  color: var(--djuli-primary-color);
}
.type {
  padding: 8px 0;
  font-weight: 500;
  text-decoration: underline;
  text-align: justify;
}
.answer,
.subanswer {
  text-align: justify;
}
.subanswer {
  padding: 12px 0;
}
section {
  padding: 1rem 2rem;
}
.cookies_subsection {
  padding: 2rem;
}
.cookies_subsection_header {
  padding: 0 2rem;
}
</style>